/**
 * First, we will load all of this project's Javascript utilities and other dependencies.
 */

require('./bootstrap');
require('./views/schedules');
import PrivacyConsent from './components/privacy-consent/PrivacyConsent';

/**
 * Popup de consentement
 */
(function () {
	new PrivacyConsent(APP.cgulink);
})();


/**
 * Active js slider d'avis dans le footer
 * @private
 */
(function () {
	const $footerCarousel = $('.owl-carousel-footer');

	if ($footerCarousel.length > 0) {
		$footerCarousel.owlCarousel({
			items: 1,
			autoplay: true,
			autoplayTimeout: 3000,
			smartSpeed: 500,
			autoplayHoverPause: true,
			loop: true
		});
	}
})();

/**
 * Automatiquement afficher des popups de notification si le Controller a envoyé un message flash
 */
(function () {
	toastr.options.positionClass = 'toast-bottom-right';
	$.each(APP.notify, function (type, msg) {
		if (msg !== '') {
			setTimeout(function () {
				switch (type) {
					case 'info':
						toastr.info(msg);
						break;
					case 'success':
						toastr.success(msg);
						break;
					case 'warning':
						toastr.warning(msg);
						break;
					case 'danger':
						toastr.error(msg);
						break;
				}
			}, 500);
		}
	});
})();

/**
 * Tooltips Bootstrap
 */
(function () {
	$('[data-toggle="tooltip"]').tooltip();
})();

/**
 * Smooth scroll au click sur une ancre
 */
(function () {
	$(document).on('click', 'a.js-smooth-scroll[href^="#"]', function (e) {
		e.preventDefault();

		let anchor = $.attr(this, 'href');
		anchor     = anchor !== '#' ? anchor : 'body';

		$('html, body').animate({
			scrollTop: $(anchor).offset().top - 150
		}, 500);
	});
})();

/**
 * Afficher le dropdown visuel "comment ça marche" du menu principal
 */
(function () {
	const navbar                = $('.main-header'),
		  howDoesItWorkDropdown = $('.main-header .how-does-it-work-dropdown');

	if (navbar.length !== 0) {
		howDoesItWorkDropdown.on('show.bs.dropdown', function () {
			openMenu();
		});

		howDoesItWorkDropdown.on('hidden.bs.dropdown', function () {
			closeMenu();
		});
	}

	function openMenu () {
		navbar.addClass('main-header--fixed');
		navbar.addClass('before-backdrop');
	}

	function closeMenu () {
		if (!navbar.hasClass('js-fixed-header-on-scroll')) {
			navbar.removeClass('main-header--fixed');
		}
		navbar.removeClass('before-backdrop');
		backdrop.hide();
	}
})();

/**
 * Afficher le dropdown visuel "Nos villes." du menu principal
 */
(function () {
	const $navbar                = $('.main-header'),
		  $howDoesItWorkDropdown = $('.main-header .js-header-cities-dropdown');

	if ($navbar.length !== 0) {
		$howDoesItWorkDropdown.on('show.bs.dropdown', function () {
			openMenu();
		});

		$howDoesItWorkDropdown.on('hidden.bs.dropdown', function () {
			closeMenu();
		});
	}

	function openMenu () {
		$('body').addClass('city--open')
		$navbar.addClass('before-backdrop');
	}

	function closeMenu () {
		$('body').removeClass('city--open')
		$navbar.removeClass('before-backdrop');
		backdrop.hide();
	}
})();

/**
 * Afficher une navbar différente en fonction du niveau de scroll
 */
(function () {
	const navbar                = $('.main-header'),
		  footer                = $('.full_width_contact_us'),
		  searchBar             = $('#searchBox'),
		  logoBlack             = $('.main-header__logo--dark'),
		  logoWhite             = $('.main-header__logo--white'),
		  howDoesItWorkDropdown = $('.main-header .how-does-it-work-dropdown'),
		  heroHeightFull        = getHeroHeight(),
		  heroHeightSticked     = getHeroHeight(false),
		  burgerToggle          = $('header.main-header .navbar-toggler');


	let lastScrollPosition = 0;

	if (navbar.length !== 0) {
		triggerNavAppearance($(window).scrollTop());

		$(window).scroll(function () {
			triggerNavAppearance($(this).scrollTop());
		});

		howDoesItWorkDropdown.on('shown.bs.dropdown', function () {
			triggerNavAppearance($(window).scrollTop());
		});

		howDoesItWorkDropdown.on('hidden.bs.dropdown', function () {
			triggerNavAppearance($(window).scrollTop());
		});

		burgerToggle.on('click', function () {
			let header        = $('header.main-header');
			let headerContent = $('#navbarSupportedContent')

			$(this).toggleClass('active')
			if ($(this).hasClass('active')) {
				searchBar.addClass('hidden')
				header.addClass('active')
				headerContent.addClass('active')
				footer.removeClass('show')
			} else {
				searchBar.removeClass('hidden')
				header.removeClass('active')
				headerContent.removeClass('active')
				footer.addClass('show')
			}

		})
	}

	function getHeroHeight (max = true) {
		let heroHeight = 0;


		if ($('.hero-element').length !== 0){
			$('.hero-element').each(function () {
				if (max || $(this).hasClass('home-jumbotron')) {
					heroHeight += $(this).outerHeight();
				}
			});

			//heroHeight -= navbar.outerHeight();

			if (window.matchMedia("(min-width: 992px)").matches) {
				// heroHeight -= navbar.outerHeight() + searchBar.outerHeight()
			}
		}else{
			heroHeight = navbar.outerHeight() + searchBar.outerHeight();
		}


		if (window.matchMedia("(max-width: 767px)").matches){
			heroHeight += 0;
		}else{
			heroHeight -= 20;
		}


		return heroHeight;
	}

	function triggerNavAppearance (scrollTop) {

		if (scrollTop > 1 ) {

			if (searchBar.hasClass('js-search-box--fixed')){
				if (scrollTop > heroHeightSticked) {
					searchBar.addClass('search-box--fixed');
				} else {
					searchBar.removeClass('search-box--fixed');
				}

				if (scrollTop > heroHeightFull) {
					if (lastScrollPosition > scrollTop) {
						searchBar.addClass('scrolled-up');
						$('body').addClass('scrolled-up');
					} else {
						searchBar.removeClass('scrolled-up');
						$('body').removeClass('scrolled-up');
						searchBar.addClass('search-box--fixed--max');
						$('body').addClass('search-box--fixed--max');
					}

				} else {
					searchBar.removeClass('search-box--fixed--max');
					$('body').removeClass('search-box--fixed--max');
				}
			}

			navbar.addClass('main-header--bg-white');
			footer.addClass('show');
			logoBlack.show();
			logoWhite.hide();
		} else {
			footer.removeClass('show');
			if (!howDoesItWorkDropdown.hasClass('show')) {
				navbar.removeClass('main-header--bg-white');
				logoBlack.hide();
				logoWhite.show();
			} else {
				navbar.addClass('main-header--bg-white');
				navbar.addClass('before-backdrop');
				logoBlack.show();
				logoWhite.hide();
			}

		}

		lastScrollPosition = scrollTop;
	}
})();

/*=======================================================*/
/*======================= FUNCTIONS =====================*/
/**
 * Hack pour empêcher Chrome de proposer des adresses dans une popup, ce qui couvre les choix de Google Place Autocomplete
 * Duh
 *
 * @param input
 */
window.stopAutocompleteHack = function (input) {
	var observerHack = new MutationObserver(function () {
		observerHack.disconnect();
		$(input).attr("autocomplete", "new-password");
	});

	observerHack.observe(input, {
		attributes: true,
		attributeFilter: ['autocomplete']
	});
};

/**
 * Afficher une toile de fond pour faire ressortir un élément au click/action dessus
 */
function Backdrop () {
	const _self            = this;
	const $triggerBackdrop = $('.js-trigger-backdrop');
	let $backdropEl        = $('.js-backdrop'),
		$body			  = $('body');

	Backdrop.prototype.init = function () {
		if ($triggerBackdrop.length > 0) {
			if ($backdropEl.length === 0) {
				$backdropEl = $('<div class="js-backdrop backdrop d-none"></div>');
				$body.prepend($backdropEl);
			}

			// Afficher la toile de fond
			$triggerBackdrop.on('click keyup', function () {
				_self.show($(this));
			});

			// Cacher la toile de fond
			$backdropEl.on('click', function () {
				_self.hide();
			});
		}
	};

	/**
	 * Afficher la toile de fond
	 */
	Backdrop.prototype.show = function ($el) {
		$backdropEl.removeClass('d-none').addClass('backdrop--active');
		$el.addClass('before-backdrop');
	};

	/**
	 * Cacher la toile de fond
	 */
	Backdrop.prototype.hide = function () {
		$backdropEl.addClass('d-none').removeClass('backdrop--active');
		$triggerBackdrop.removeClass('before-backdrop');
	};
}

const backdrop = new Backdrop();
backdrop.init();
window.layoutBackdrop = backdrop;

/**
 * Obfusquer certains liens pour le maillage interne du SEO
 */
(function () {
	const $obfLink = $('.js-obflink');

	if ($obfLink.length > 0) {
		if ($obfLink.attr('tabindex') === undefined) {
			$obfLink.attr('tabindex', '0'); // Pour l'accessibilité
		}

		if ($obfLink.attr('aria-label') === undefined) {
			$obfLink.attr('aria-label', 'Cette balise est un lien cliquable'); // Pour l'accessibilité
		}

		$obfLink.on('click', function () {
			var link = atob($(this).data('o'));

			if ($(this).data('target') === '_blank') {
				window.open(link);
			} else {
				window.location = link;
			}
		});
	}
})();

/**
 * Lazy loading des vidéos : On click on load la vidéo.
 */
(function () {

	var youtube = document.querySelectorAll(" .youtube");

	for (var i = 0; i < youtube.length; i++) {

		if(GLOBAL.webp_support){
			var source = "https://img.youtube.com/vi_webp/" + youtube[i].dataset.embed + "/mqdefault.webp";
		}else{
			var source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/mqdefault.jpg";
		}

		var image = new Image();
		image.src = source;
		image.alt = youtube[i].dataset.alt?youtube[i].dataset.alt:"Video Youtube";
		image.addEventListener("load", function () {
			youtube[i].appendChild(image);
		}(i));

		youtube[i].addEventListener("click", function () {

			var iframe = document.createElement("iframe");

			iframe.setAttribute("frameborder", "0");
			iframe.setAttribute("allowfullscreen", "");
			iframe.setAttribute("loading", "lazy");
			iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");

			this.innerHTML = "";
			this.appendChild(iframe);
		});
	}
})();
